import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { client } from '../../../../gql/client';
import { FETCH_USER_GROUPS } from '../../../../gql/queries/userGroups';
import { FETCH_APP_USERS } from '../../../../gql/queries/users';

// Utils
import { AuthContextType } from '../../../../hooks/useAuth';

// Types
import { AppUserOption, GroupsManagementLoaderData } from './types';

export const GroupsManagementLoader: (
    userData: AuthContextType | null
) => LoaderFunction | undefined = (userData) => async () => {
    // La promesa llega PENDIENTE al `<Await>`: la navegación termina al
    // instante y el `<Fallback>` enseña el Loader dentro de la pantalla nueva.
    const load = async (): Promise<GroupsManagementLoaderData> => {
        if (!userData?.user) return { groups: [], appUsers: [] };
        try {
            const [groupsResult, usersResult] = await Promise.all([
                client.query({ query: FETCH_USER_GROUPS, fetchPolicy: 'network-only' }),
                // Red siempre: una persona dada de alta o de baja tiene que
                // salir (o desaparecer) en el desplegable sin recargar la app.
                client.query({ query: FETCH_APP_USERS, fetchPolicy: 'network-only' }),
            ]);

            const appUsers: AppUserOption[] = (usersResult.data?.appUsers ?? []).map(
                (u: AppUserOption) => ({
                    id: u.id,
                    name: u.name,
                    surName: u.surName,
                    email: u.email,
                    rolActive: u.rolActive,
                    isActive: u.isActive,
                })
            );

            return { groups: groupsResult.data?.userGroups ?? [], appUsers };
        } catch (err) {
            Sentry.captureException(err);
            console.log('> Groups management loader error:', err);
            return { groups: [], appUsers: [] };
        }
    };

    return { data: load() };
};
